import { render, staticRenderFns } from "./PropertyCalendarSidebarItemTest.vue?vue&type=template&id=d1e4f096&scoped=true&"
import script from "./PropertyCalendarSidebarItemTest.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarSidebarItemTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e4f096",
  null
  
)

export default component.exports